import type { ChatMessage, ChatMessagePart } from '@mui/x-chat/types';

interface AgenticChatActivityOptions {
  part: ChatMessagePart;
  message: ChatMessage;
  index: number;
}

/** Only the last reasoning part or an unfinished tool owns the live activity indicator. */
export function isAgenticChatActivityActive(options: AgenticChatActivityOptions) {
  const { part, message, index } = options;
  return (
    message.status === 'streaming' &&
    (part.type === 'reasoning'
      ? part.state === 'streaming' && index === message.parts.length - 1
      : (part.type === 'tool' || part.type === 'dynamic-tool') &&
        (part.toolInvocation.preliminary === true ||
          ['input-streaming', 'input-available', 'approval-responded'].includes(
            part.toolInvocation.state
          )))
  );
}
